export default "__VITE_ASSET__C2Qd5YaD__"